import { Color } from './Color';
import { TextAlignment } from './TextAlignment';
export class TextStyle {
    constructor() {
        this.type = 'TextStyle';
    }
    static hydrate(data) {
        const textStyle = new TextStyle();
        if (typeof data.textColor !== 'undefined') {
            textStyle.textColor = new Color(data.textColor._hexaValue);
        }
        if (typeof data.strokeColor !== 'undefined') {
            textStyle.strokeColor = new Color(data.strokeColor._hexaValue);
        }
        if (typeof data.backgroundColor !== 'undefined') {
            textStyle.backgroundColor = new Color(data.backgroundColor._hexaValue);
        }
        if (typeof data.textAlignment !== 'undefined') {
            textStyle.textAlignment = new TextAlignment(data.textAlignment.value);
        }
        for (const key in data) {
            if (typeof textStyle[key] == 'undefined') {
                textStyle[key] = data[key];
            }
        }
        return textStyle;
    }
}
